// Password Actions
export const SET_NEW_USER_PASSWORD = 'USER/SET_NEW_USER_PASSWORD'
